import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import TenantManagement from '../pages/TenantManagement';
import TenantDetails from '../pages/TenantDetails';
import SystemLogs from '../pages/SystemLogs';
import TenantLogs from '../pages/TenantLogs';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ListIcon from '@mui/icons-material/List';
import TenantUsers from '../pages/TenantUsers';
import SystemUsers from '../pages/SystemUsers';
import TenantUserCreate from '../pages/TenantUserCreate';
import TenantUserDetails from '../pages/TenantUserDetails';
import TenantUserEdit from '../pages/TenantUserEdit';
import SystemUserCreate from '../pages/SystemUserCreate';
import SystemUserDetails from '../pages/SystemUserDetails';
import SystemUserEdit from '../pages/SystemUserEdit';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ProfilePage from '../pages/Profile';
import ClientsPage from '../pages/Clients';
import ClientDetails from '../pages/ClientDetails';
import RolesPage from '../pages/Roles';
import RoleDetails from '../pages/RoleDetails';
import PermissionsPage from '../pages/Permissions';
import PermissionDetails from '../pages/PermissionDetails';
import UserProfilesPage from '../pages/UserProfiles';
import UserProfileDetails from '../pages/UserProfileDetails';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

const routes = [
    {
        id: 1001,
        parent: null,
        icon: '',
        isPublicRoute: true,
        path: '',
        name: 'login',
        label: "Login",
        tooltip: "Login",
        component: LoginPage,
        exact: true,
        topMenu: false,
        subMenu: false
    },
    {
        id: 1011,
        icon: '',
        isPublicRoute: false,
        path: 'profile',
        name: 'profile',
        label: "Profile",
        tooltip: "Profile",
        component: ProfilePage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 1021,
        icon: <DashboardIcon></DashboardIcon>,
        isPublicRoute: false,
        path: 'dashboard',
        name: 'dashboard',
        label: "Dashboard",
        tooltip: "Dashboard",
        component: HomePage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subMenu: false
    },
    {
        id: 2011,
        icon: <AppsOutlinedIcon />,
        isPublicRoute: false,
        path: 'clients',
        name: 'Clients',
        label: "Clients",
        tooltip: "Clients",
        component: ClientsPage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subMenu: false
    },
    {
        id: 2012,
        isPublicRoute: false,
        path: 'clients/view/:clientId',
        name: 'Client Details',
        label: "Client Details",
        tooltip: "Client Details",
        component: ClientDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 2021,
        icon: <BadgeOutlinedIcon />,
        isPublicRoute: false,
        path: 'roles',
        name: 'Roles',
        label: "Roles",
        tooltip: "Roles",
        component: RolesPage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subMenu: false
    },
    {
        id: 2022,
        isPublicRoute: false,
        path: 'roles/view/:roleId',
        name: 'Role Details',
        label: "Role Details",
        tooltip: "Role Details",
        component: RoleDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 2031,
        icon: <VpnKeyOutlinedIcon />,
        isPublicRoute: false,
        path: 'permissions',
        name: 'Permissions',
        label: "Permissions",
        tooltip: "Permissions",
        component: PermissionsPage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subMenu: false
    },
    {
        id: 2032,
        isPublicRoute: false,
        path: 'permissions/view/:permissionId',
        name: 'Permission Details',
        label: "Permission Details",
        tooltip: "Permission Details",
        component: PermissionDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 2033,
        icon: <AssignmentIndOutlinedIcon />,
        isPublicRoute: false,
        path: 'user-profiles',
        name: 'User Profiles',
        label: "User Profiles",
        tooltip: "User Profiles",
        component: UserProfilesPage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subMenu: false
    },
    {
        id: 2034,
        isPublicRoute: false,
        path: 'user-profiles/view/:profileName',
        name: 'User Profile Details',
        label: "User Profile Details",
        tooltip: "User Profile Details",
        component: UserProfileDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 2041,
        icon: <AppsOutlinedIcon />,
        isPublicRoute: false,
        path: 'tenant-clients',
        name: 'Tenant Clients',
        label: "Clients",
        tooltip: "Tenant Clients",
        component: ClientsPage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 20411,
        isPublicRoute: false,
        path: 'tenant-clients/view/:clientId',
        name: 'Tenant Client Details',
        label: "Client Details",
        tooltip: "Client Details",
        component: ClientDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 2042,
        icon: <BadgeOutlinedIcon />,
        isPublicRoute: false,
        path: 'tenant-roles',
        name: 'Tenant Roles',
        label: "Roles",
        tooltip: "Tenant Roles",
        component: RolesPage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 20421,
        isPublicRoute: false,
        path: 'tenant-roles/view/:roleId',
        name: 'Tenant Role Details',
        label: "Role Details",
        tooltip: "Role Details",
        component: RoleDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 2043,
        icon: <VpnKeyOutlinedIcon />,
        isPublicRoute: false,
        path: 'tenant-permissions',
        name: 'Tenant Permissions',
        label: "Permissions",
        tooltip: "Tenant Permissions",
        component: PermissionsPage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 20431,
        isPublicRoute: false,
        path: 'tenant-permissions/view/:permissionId',
        name: 'Tenant Permission Details',
        label: "Permission Details",
        tooltip: "Permission Details",
        component: PermissionDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 2044,
        icon: <AssignmentIndOutlinedIcon />,
        isPublicRoute: false,
        path: 'tenant-user-profiles',
        name: 'Tenant User Profiles',
        label: "User Profiles",
        tooltip: "Tenant User Profiles",
        component: UserProfilesPage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 20441,
        isPublicRoute: false,
        path: 'tenant-user-profiles/view/:profileName',
        name: 'Tenant User Profile Details',
        label: "User Profile Details",
        tooltip: "Tenant User Profile Details",
        component: UserProfileDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        tenantContext: true,
        subMenu: false
    },
    {
        id: 1031,
        icon: <GroupOutlinedIcon />,
        isPublicRoute: false,
        path: '',
        name: 'User Management',
        label: "User Management",
        tooltip: "User Management",
        component: HomePage,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subItems:[
            {
                id: 10311,
                icon: <PersonSearchOutlinedIcon />,
                isPublicRoute: false,
                path: 'systemusers',
                name: 'System Users',
                label: "System Users",
                tooltip: "System Users",
                component: SystemUsers,
                exact: true,
                topMenu: false,
                leftMenu: true,
            },
            {
                id: 10312,
                icon: <ManageAccountsIcon />,
                isPublicRoute: false,
                path: 'tenantusers',
                name: 'Tenant Users',
                label: "Tenant Users",
                tooltip: "Tenant Users",
                component: TenantUsers,
                exact: true,
                topMenu: false,
                leftMenu: true,
            }
        ]
    },
    {
        id: 10313,
        isPublicRoute: false,
        path: 'systemusers/create',
        name: 'Create System User',
        label: "Create System User",
        tooltip: "Create System User",
        component: SystemUserCreate,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 10314,
        isPublicRoute: false,
        path: 'systemusers/view/:userId',
        name: 'System User Details',
        label: "System User Details",
        tooltip: "System User Details",
        component: SystemUserDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 10317,
        isPublicRoute: false,
        path: 'systemusers/edit/:userId',
        name: 'Edit System User',
        label: "Edit System User",
        tooltip: "Edit System User",
        component: SystemUserEdit,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 10315,
        isPublicRoute: false,
        path: 'tenantusers/create',
        name: 'Create Tenant User',
        label: "Create Tenant User",
        tooltip: "Create Tenant User",
        component: TenantUserCreate,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 10316,
        isPublicRoute: false,
        path: 'tenantusers/view/:userId',
        name: 'Tenant User Details',
        label: "Tenant User Details",
        tooltip: "Tenant User Details",
        component: TenantUserDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 10318,
        isPublicRoute: false,
        path: 'tenantusers/edit/:userId',
        name: 'Edit Tenant User',
        label: "Edit Tenant User",
        tooltip: "Edit Tenant User",
        component: TenantUserEdit,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 1041,
        icon: <ApartmentOutlinedIcon />,
        isPublicRoute: false,
        path: '',
        name: 'Tenant Management',
        label: "Tenant Management",
        tooltip: "Tenant Management",
        component: TenantManagement,
        exact: true,
        topMenu: false,
        leftMenu: true,
        subItems: [
            {
                id: 10411,
                icon: <ListIcon />,
                isPublicRoute: false,
                path: 'tenantmgmt',
                name: 'Tenants',
                label: "Tenants",
                tooltip: "Tenants",
                component: TenantManagement,
                exact: true,
                topMenu: false,
                leftMenu: true,
            }
        ]
    },
    {
        id: 10412,
        isPublicRoute: false,
        path: 'tenantmgmt/view/:tenantId',
        name: 'Tenant Details',
        label: "Tenant Details",
        tooltip: "Tenant Details",
        component: TenantDetails,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subMenu: false
    },
    {
        id: 1051,
        icon: <SettingsSuggestOutlinedIcon />,
        isPublicRoute: false,
        path: 'clientconfig',
        name: 'Client Configuration',
        label: "Client Configuration",
        tooltip: "Client Configuration",
        component: ClientsPage,
        exact: true,
        topMenu: false,
        leftMenu: false,
        subItems: []
    },
    {
        id: 1061,
        icon: <FactCheckOutlinedIcon />,
        isPublicRoute: false,
        path: '',
        name: 'Audit Logs',
        label: "Audit Logs",
        tooltip: "Audit Logs",
        exact: true,
        topMenu: false,
        leftMenu: true,
        subItems: [
            {
                id: 10611,
                icon: <StorageOutlinedIcon />,
                isPublicRoute: false,
                path: 'systemlogs',
                name: 'System Logs',
                label: "System Logs",
                tooltip: "System Logs",
                component: SystemLogs,
                exact: true,
                topMenu: false,
                leftMenu: true,
                subMenu: false
            },
            {
                id: 10612,
                icon: <GroupsOutlinedIcon />,
                isPublicRoute: false,
                path: 'tenantLogs',
                name: 'Tenant Logs',
                label: "Tenant Logs",
                tooltip: "Tenant Logs",
                component: TenantLogs,
                exact: true,
                topMenu: false,
                leftMenu: true,
                subMenu: false
            }
        ]
    }
];

export default routes;